import { useEffect, useState } from 'react';

/*
 * useMediaQuery
 *
 */
export const useMediaQuery = (query: string) => {
  // We call this function first to get a value for the initial render.
  const getMatch = (q: string) => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return false;
    }

    return window.matchMedia(q).matches;
  };

  const [match, setMatch] = useState(getMatch(query));

  const onChange = (event: MediaQueryListEvent) => {
    setMatch(event.matches);
  };

  useEffect(() => {
    const mediaQueryList = window?.matchMedia(query);

    if (
      mediaQueryList &&
      typeof mediaQueryList.addEventListener === 'function'
    ) {
      mediaQueryList.addEventListener('change', onChange);
      setMatch(mediaQueryList.matches);
    } else {
      setMatch(false);
    }

    return () => {
      if (
        mediaQueryList &&
        typeof mediaQueryList.removeEventListener === 'function'
      ) {
        mediaQueryList.removeEventListener('change', onChange);
      }
    };
  }, [query]);

  return match;
};
